import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "./assets/sass/index.scss";
import "./assets/sass/myVariables.scss";
import "./assets/sass/AppointmentScheduler.scss";
import "./assets/sass/dashboard.scss";
import "./assets/sass/InitialEvaluation.scss";
import "./assets/sass/myNav.scss";
import "./assets/sass/onePatientPage.scss";
import "./assets/sass/PhonePreEvaluation.scss";
import "./assets/sass/QueryFilterResults.scss";
import "./assets/sass/RCSelect.scss";
import { InitializationContextProvider } from "./context/InitializationContext";
import { AuthContextDataProvider } from "./context/AuthContext";
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import "@devexpress/dx-react-chart-bootstrap4/dist/dx-react-chart-bootstrap4.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./i18n";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    // <React.StrictMode>
    <BrowserRouter>
        <InitializationContextProvider>
            <AuthContextDataProvider>
                <App />
            </AuthContextDataProvider>
        </InitializationContextProvider>
    </BrowserRouter>,
    // </React.StrictMode>
);
